/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExpressionStrategyFactory } from './ExpressionStrategyFactory';
import { GraphNode } from '../../graph/GraphNode';
import { GraphUtil } from '../util/GraphUtil';

export class ExpressionConverter {
    private strategyFactory: ExpressionStrategyFactory =
        new ExpressionStrategyFactory();

    getNodeExpression(node: GraphNode, analyticName?: string): string {
        const strategy = this.strategyFactory.getStrategy(node);
        return strategy.buildEngineNodeExpression(node, analyticName);
    }
    convertToEngineExpression(
        userExpression: string,
        engineGraph: GraphUtil,
        analyticName?: string,
    ): string {
        if (!engineGraph)
            throw new Error('Diagram is empty or constructed incorrectly.');

        if (!userExpression) throw new Error('Expression cannot be empty.');

        let finalExpression = userExpression;
        //sort it to avoid similar name replacement issue i.e. a1 and a
        const sortedNodeEntries = [...engineGraph.nodes.entries()].sort(
            (a, b) => {
                // First sort by length (longer names first)
                if (a[0].length !== b[0].length) {
                    return b[0].length - a[0].length;
                }
                // If same length, sort alphabetically in reverse order
                return b[0].localeCompare(a[0]);
            },
        );
        const sortedNodes: Map<string, GraphNode> = new Map(sortedNodeEntries);
        sortedNodes.forEach((n) => {
            finalExpression = finalExpression
                .split('@' + n.name)
                .join(this.getNodeExpression(n, analyticName));
        });

        return finalExpression;
    }
}
